import { isBeautifulLinkBasedOnId } from './beautifiedPrefix';
import { OUTLOOK_BEAUTIFIED_PREFIX } from './constants';
import { OWA_AUTO_LINKS_CLASSNAME } from 'owa-compose-link';
import { getGuid } from 'owa-guid';

const classNames = require('classnames');
const ID_PREFIX = 'OWA';
export default function trySetIdAndClassName(
    anchorElement: HTMLAnchorElement,
    shouldChangeLinkId: boolean
) {
    if (!anchorElement.id || anchorElement.id.length === 0 || shouldChangeLinkId) {
        if (isBeautifulLinkBasedOnId(anchorElement)) {
            anchorElement.id = OUTLOOK_BEAUTIFIED_PREFIX + getGuid();
        } else {
            anchorElement.id = ID_PREFIX + getGuid();
        }
    }
    if (anchorElement.className.indexOf(OWA_AUTO_LINKS_CLASSNAME) !== -1) {
        return;
    }

    anchorElement.className = classNames(anchorElement.className, OWA_AUTO_LINKS_CLASSNAME);
}
